import { render, staticRenderFns } from "./suggestion-comp.vue?vue&type=template&id=26c00fa6&scoped=true&"
import script from "./suggestion-comp.vue?vue&type=script&lang=js&"
export * from "./suggestion-comp.vue?vue&type=script&lang=js&"
import style0 from "./suggestion-comp.vue?vue&type=style&index=0&id=26c00fa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c00fa6",
  null
  
)

export default component.exports